module.exports = __webpack_public_path__ + "static/media/day-icon.492cce4e.svg";